import React from 'react';
import $ from 'jquery';
import Axios from 'axios';
import { Segment } from 'semantic-ui-react';

export default class Shift4Iframe extends React.Component {
  constructor(props) {
    super(props);

    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleFailure = this.handleFailure.bind(this);
    this.handleLoadFailure = this.handleLoadFailure.bind(this);
  }

  async componentDidMount() {
    const { setLoading } = this.props;
    const { handleSuccess } = this;
    const { handleFailure } = this;

    setLoading(true);

    this.$el = $(this.el);
    window.jQuery = $;

    await this.loadScript('https://i4m.i4go.com/js/jquery.i4goTrueToken.js');

    try {
      const { data: accessBlock } = await this.retrieveAccessBlock();

      (() => {
        const i4goConfig = {
          server: accessBlock.i4go_server,
          accessBlock: accessBlock.i4go_accessblock,
          template: 'bootstrap2',
          self: window.location,
          url: accessBlock.i4go_i4m_url,
          frameContainer: 'i4goFrame',
          frameAutoResize: true,
          submitButton: {
            label: 'Submit',
          },
          async onSuccess(form, data) {
            handleSuccess(data);
          },
          onFailure(form, data) {
            handleFailure(data);
          },
          acceptedPayments: 'AX,DC,MC,VS',
          language: 'en',
          label: { classes: 'hidden' },
          cssRules: [],
        };

        $('#form-main').i4goTrueToken(i4goConfig);
        setLoading(false);
      })();
    } catch (e) {
      this.handleLoadFailure(e);
      setLoading(false);
    }
  }

  loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.src = src;
      document.head.appendChild(script);

      script.onload = () => {
        resolve();
      };
    });
  }

  async retrieveAccessBlock() {
    const { locationId } = this.props;
    const host = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
    return Axios.get(`${host}ordering/payments/locations/${locationId}/access_block/`);
  }

  handleSuccess(data) {
    const { handleSuccess } = this.props;
    handleSuccess(data);
  }

  handleFailure(data) {
    const { handleFailure } = this.props;
    handleFailure(data);
  }

  handleLoadFailure(data) {
    const { handleLoadFailure } = this.props;
    handleLoadFailure(data);
  }

  render() {
    return (
      <Segment style={{ margin: '0 -1rem' }}>
        <form id="form-main" action="" method="post">
          <input id="i4go_response" name="i4go_response" type="hidden" />
          <input id="i4go_responsecode" name="i4go_responsecode" type="hidden" />
          <input id="i4go_responsetext" name="i4go_responsetext" type="hidden" />
          <input id="i4go_cardtype" name="i4go_cardtype" type="hidden" />
          <input id="i4go_maskedcard" name="i4go_maskedcard" type="hidden" />
          <input id="i4go_uniqueid" name="i4go_uniqueid" type="hidden" />
          <input id="i4go_expirationmonth" name="i4go_expirationmonth" type="hidden" />
          <input id="i4go_expirationyear" name="i4go_expirationyear" type="hidden" />
          <input id="i4go_cardholdername" name="i4go_cardholdername" type="hidden" />
          <input id="i4go_streetaddress" name="i4go_streetaddress" type="hidden" />
          <input id="i4go_postalcode" name="i4go_postalcode" type="hidden" />
          <input id="i4go_metatoken" name="i4go_metatoken" type="hidden" />
        </form>
        <div ref={el => (this.el = el)} id="i4goFrame" style={{ margin: '0 -1rem' }} />
      </Segment>
    );
  }
}
